import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SportParameterizationComponentList } from './sport-parameterization-list/sport.parameterization-list.component';
import { SportParameterizationComponentForm } from './sport-parameterization-form/sport.parameterization-form.component';


const routes: Routes = [
  {
    path: '',
    component: SportParameterizationComponentList
  },
  {
    path: 'editar/:espNrId',
    component: SportParameterizationComponentForm
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SportParameterizationRoutingModule { }
